<template>
  <div>
    <vx-card
      class="conversions-table-section campaigns-table mt-1"
      :noShadow="true">
      <!-- Start Table Header -->
      <template v-slot:actions>
        <div class="conversions-list-title md:flex">
          <!-- Start Filteration Summary -->
          <filter-summary
            v-if="showFilterCounter"
            :filterCounter="filterCounter"
            :filters="agFilters"
            :filteredCampaigns="filteredCampaigns"
            @clear-filters="clearFilters"
          ></filter-summary>
          <!-- End Filteration Summary -->
        </div>

        <!-- Start Table Filteration -->
        <div class="mt-2 md:flex buttons-parent">
          <div class="date-picker-li">
            <speakol-date-range-picker
              @click.native="$gtag.event('Campaigns_date_range_apply')"
              id="campaigns-date-range-picker-input"
              class="conversions-datePicker"
              v-model="agFilters.dateRange"
              :placeholder="$t('Filter by date')"
              :minimumDate="minDate"
              @input="applyFilters()"
              :key="resetDateRange"
            >
            </speakol-date-range-picker>
          </div>

          <div class="all-filters-li float-right ml-3">
            <button id="campaigns-all-filters-button" class="shadow-none speakol-table-all-filters-button" @click="showAllFilters = !showAllFilters">
              <vs-icon class="speakol-filters" icon="speakol-filters" icon-pack="speakol"></vs-icon>
              <span class="all-filters-span">
                {{ $t('All Filters') }}
              </span>
            </button>
          </div>

          <div class="create-conv-li-mobile-version float-right ml-3">
            <div class="empty-state-action">
              <router-link :to="{ name: 'conversions-create'}">
                <button @click="$gtag.event('Create_Conversion')" class="shadow-none create-conversion-button">{{ $t("tracking.conversions_tab.btn_create") }}</button>
              </router-link>
            </div>
          </div>
        </div>

        <div v-show="showAllFilters" :key="clearTreeSelect" :class="{ bindingFiltersContainer: showFilterCounter }" id="filters-container" class="filters-container">
          <ul class="advertisers-table-desktop-version">
            <li class="mb-6">
              <div class="campagin-search-parent">
                <speakol-checkbox-tree
                  id="ads-all-campaigns-list"
                  class="w-full mb-6 md:mb-0 md:input md:mr-4"
                  :fetchFunction="getCampaignsOptions"
                  :includeAll="true"
                  placeholder="All Campaigns"
                  ref="campaigns-filter"
                  @input="handleCampaignSelected"
                  singleMaxWidth="130px"
                  multipleMaxWidth="140px"
                />
              </div>
            </li>

            <li class="mb-6">
              <treeselect id="campaigns-all-events-input" :options="pixelEvents" v-model="agFilters.event" placeholder="Conversions"></treeselect>
            </li>

            <li class="mb-6 hidden">
              <treeselect id="campaigns-all-status-input" :options="conversionStatuses" v-model="agFilters.status" placeholder="All Status"></treeselect>
            </li>

            <li class="mb-4">
              <button id="campaigns-filter-button" class="w-full shadow-none speakol-table-filter-button" @click="applyFilters">
                {{ $t('Filter') }}
              </button>
            </li>

            <li class="">
              <button id="campaigns-cancel-button" class="w-full shadow-none speakol-table-cancel-button" @click="closeFilters">
                {{ $t('Cancel') }}
              </button>
            </li>

          </ul>
        </div>
        <!-- End Table Filteration -->
        <!-- End Table Header -->
      </template>

      <tableViewCodePopup />

      <!-- Start Conversions Table -->
      <a-g-speakol-table
        ref="conversionsTable"
        :filters="agFiltersCopy"
        :columns="agColumns"
        :options="agOptions"
      ></a-g-speakol-table>
      <!-- End Conversions Table -->
    </vx-card>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {mapGetters} from 'vuex'
import {without, get} from 'lodash'
import AGSpeakolTable from '@/components/AGSpeakolTable'
import ConversionsDataSource from '@/datasources/ConversionsDataSource'
import FilterSummary from './FilterSummary.vue'
import ConversionStatus from './ConversionStatus'
import MainPixelCodeStatus from './MainPixelCodeStatus'
import ActionsColumn from './ActionsColumn'
import CampaignName from './CampaignName'
import tableViewCodePopup from './tableViewCodePopup'
import DateTime from './DateTime'
import StatusHeader from './StatusHeader'

export default {
  components: {
    Treeselect,
    AGSpeakolTable,
    FilterSummary,
    ConversionStatus,
    MainPixelCodeStatus,
    ActionsColumn,
    tableViewCodePopup,
    CampaignName,
    DateTime,
    StatusHeader
  },
  data () {
    return {
      agFiltersCopy: {},
      resetDateRange: Math.random(),
      campaigns: [],
      filteredCampaigns: [],
      agFilters: this.getFilterationInitState(),
      minDate: this.calculateMinDate(),
      agOptions: {
        dataSource: ConversionsDataSource
      },
      agColumns: this.getAgGridColumns(),
      conversionStatuses: this.$constants.CONVERSION_STATUS,
      showAllFilters: false,
      clearTreeSelect: Math.random(),
      showFilterCounter: false,
      filterCounter: 0
    }
  },

  async created () {
    await this.$store.dispatch('campaign/getAccountCampaigns', {
      'exclude_objectives': [this.$constants.CAMPAIGN_OBJECTIVES_IDS.LEAD_FORM]
    })
  },

  computed: {
    ...mapGetters({
      pixelEvents: 'campaign/pixelEvents',
      accountCampagins: 'campaign/loggedInAccountCampaigns'
    })
  },

  methods: {
    calculateStartDate () {
      const accountCreatedAt = new this.$moment(this.$store.getters['authentication/activeAccount'].created_at)
      return accountCreatedAt.format('YYYY-MM-DD')
    },

    calculateMinDate () {
      return new Date(new this.$moment(this.$store.getters['authentication/activeAccount'].created_at).subtract(1, 'days'))
    },
    setFilterCounterShow (boolValue) {
      this.showFilterCounter = boolValue
    },
    setAllFilterShow (boolValue) {
      this.showAllFilters = boolValue
    },
    getFilterationInitState () {
      return {
        event: null,
        status: null,
        campaignsIds: [],
        dateRange: {
          startDate: this.calculateStartDate(),
          endDate: new Date()
        }
      }
    },
    // Get Campaigns Options //
    async getCampaignsOptions () {
      return this.accountCampagins.map((campaign) => {
        const { id, name } = campaign
        return {
          id,
          label: name
        }
      })
    },

    // Handling Campaign Selected //
    handleCampaignSelected (selectedCampaignsIds) {
      const campaigns = this.accountCampagins
      const allAreadyExist = campaigns.find(campaign => campaign.id === -1)

      if (selectedCampaignsIds.includes(-1) && !allAreadyExist) {
        campaigns.push({
          id: -1,
          name: 'All'
        })
      }

      this.filteredCampaigns = campaigns.filter(campaign => selectedCampaignsIds.includes(campaign.id))

      this.agFilters.campaignsIds = without(selectedCampaignsIds, -1)
    },

    filterCount () {
      this.filterCounter = 0

      Object.keys(this.agFilters).forEach(key => {
        let value = this.agFilters[key]
        if (key === 'dateRange') {
          return
        }
        if (Array.isArray(value)) {
          value = value.length
        }

        if (value) {
          this.filterCounter++
        }
      })

      if (this.filterCounter === 0) {
        this.setFilterCounterShow(false)
      }

      return this.filterCounter
    },

    activeFilters () {
      if (this.agFilters.campaignsIds || this.agFilters.status || this.agFilters.event) {
        return true
      }

      return false
    },
    async clearFilters () {
      this.agFilters.event = null
      this.agFilters.status = null
      this.agFilters.campaignsIds = []

      this.agFilters.dateRange = {
        startDate: await this.calculateStartDate(),
        endDate: new Date()
      }

      this.clearTreeSelect = Math.random()
      this.resetDateRange = Math.random()
      this.setFilterCounterShow(false)

      this.applyFilters()
    },
    closeFilters () {
      this.setAllFilterShow(false)
    },
    getAgGridColumns () {
      return [
        {
          headerName: 'Conversion Name',
          field: 'conversion_name',
          minWidth: 210,
          sortable: true,
          valueGetter (params) {
            if (params.data) {
              const conversion = params.data.conversion_name.replace(/_/g, ' ')

              return conversion.charAt(0).toUpperCase() + conversion.slice(1)
            }
          }
        },
        {
          headerName: 'Campaign Name',
          field: 'campaign_name',
          minWidth: 300,
          autoHeight: true,

          sortable: true,
          cellRendererFramework: 'CampaignName'
        },
        {
          headerName: 'Main Pixel Code',
          field: 'main_pixel_code_status',
          minWidth: 200,
          sortable: false,
          cellRendererFramework: 'MainPixelCodeStatus',
          headerComponentFramework: 'StatusHeader'
        },
        {
          headerName: 'Status',
          field: 'status',
          minWidth: 200,
          sortable: false,
          cellRendererFramework: 'ConversionStatus',
          headerComponentFramework: 'StatusHeader'
        },
        {
          headerName: 'Conversions Received',
          field: 'conversions',
          autoHeight: true,
          minWidth: 220,
          sortable: false,
          valueGetter (params) {
            if (params.data) {
              return params.data.conversions.toLocaleString()
            }
          }
        },
        {
          headerName: 'Created On',
          field: 'created_at',
          minWidth: 200,
          sortable: true,
          cellRendererFramework: 'DateTime'
        },
        {
          headerName: 'Actions',
          field: 'actions',
          minWidth: 200,
          cellRendererFramework: 'ActionsColumn'

        }
      ]
    },
    applyFilters () {
      this.agColumns = this.getAgGridColumns()
      this.agFilters.dateRange = this.formatFilterationDate(this.agFilters.dateRange)

      this.agFiltersCopy.dateRange = this.agFilters.dateRange
      this.agFiltersCopy.event = get(this, 'agFilters.event') === 'leads' ? 'lead' : this.agFilters.event
      this.agFiltersCopy.status = this.agFilters.status
      this.agFiltersCopy.campaignsIds = this.agFilters.campaignsIds

      if (this.$refs['conversionsTable']) {
        this.$refs['conversionsTable'].applyFilters()
      }

      this.setAllFilterShow(false)
      this.setFilterCounterShow(true)
      this.filterCount()
    },

    formatFilterationDate (dateRange) {
      return {
        startDate : this.$moment(dateRange.startDate).format('YYYY-MM-DD'),
        endDate : this.$moment(dateRange.endDate).format('YYYY-MM-DD')
      }
    }
  }
}
</script>

<style scoped lang="scss">
$blueColor: #0092d7;
$darkBlueColor: #2c2c2c;
$lightBlueColor: #d9d9d9;
$whiteColor: #dedede;
$babyBlueColor: #cfcfcf;
$darkGrayColor: #616161;

.conversions-table-section {
  margin-top: 2px;
}

.filters-container {
  background-color: white;
  border: 1px solid $whiteColor;
  border-radius: 5px;
  width: 348px;
  position: absolute;
  right: 203px;
  top: 76px;
  z-index: 1;
  padding: 29px;
}

.conversions-list-title {
  position: absolute;
  left: 20px;
  top: 25px;
}

.create-conversion-button {
  background-color: $blueColor;
  color: white;
  border-radius: 3px !important;
  padding: 7px 20px;
  border: 1px solid $blueColor;
  width: 172px;
  cursor: pointer;
  height: 40px;
  font-size: 14px;
  font-weight: 500 !important;
}

.speakol-table-all-filters-button {
  background-color: white;
  color: $blueColor;
  border: 1px solid $blueColor;
  border-radius: 3px;
  padding: 7px 0 7px 25px;
  width: 135px;
  cursor: pointer;
  height: 40px;
  position: relative;
  font-size: 14px;
}

.speakol-filters {
  color: $blueColor !important;
  position: absolute;
  margin-left: -30px;
  margin-top: -2px;
  font-size: 20px !important;
}

.date-picker-li {
  .vue-daterange-picker {
    padding-bottom: 9px !important;
  }
}

.speakol-table-filter-button {
  background-color: $blueColor;
  color: white;
  border-radius: 3px;
  padding: 7px 20px;
  border: 1px solid $blueColor;
  cursor: pointer;
  height: 40px;
  font-size: 14px;
}

.speakol-table-cancel-button {
  background-color: white;
  color: $darkBlueColor;
  border: 1px solid $lightBlueColor;
  border-radius: 3px;
  padding: 7px 20px;
  width: 135px;
  cursor: pointer;
  height: 40px;
  font-size: 14px;
}

.vx-card__title,
.vx-card__actions {
  width: 100%;
}

.vs-con-input {
  width: 168px;
  height: 40px;
  float: right;
}

.vs-input--input {
  border: 1px solid $babyBlueColor !important;
}

.vs-input--input:focus {
  box-shadow: none !important;
}

.vs-icon {
  color: $babyBlueColor;
}

/deep/ .speakol-date-range-picker {
  width: 260px !important;
}

.first-line-filters {
  width: 260px !important;
}

/deep/ .vue-treeselect--searchable:not(.vue-treeselect--disabled) .vue-treeselect__value-container {
  height: 38px !important;
  position: relative;
  top: 2px;
  border-radius: 3px;
}

.sub-accounts-filter {
  width: 260px !important;
}

/deep/ .vs-con-input {
  width: 260px;
  position: relative;
  top: 0;
}

.campagin-search-icon {
  position: absolute;
  z-index: 9;
  top: 8px;
  left: 10px;
}

.campagin-search-parent {
  position: relative;
}

/deep/ .vue-treeselect__value-remove {
  svg {
    width: 7px !important;
  }
}

/deep/ .vue-treeselect__multi-value-label {
  font-size: 11px !important;
}

@media (max-width: 768px) {
  .all-filters-li,
  .speakol-table-all-filters-button,
  .create-conv-li-mobile-version,
  .create-conversion-button,
  .date-picker-li,
  .speakol-date-range-picker {
    width: 100% !important;
  }

  /deep/ .vx-card__actions {
    width: 100% !important;
  }

  .speakol-table-all-filters-button {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .conversions-list-title {
    position: inherit;
  }

  .filters-container {
    right: 21px;
    width: 299px;
    top: 193px;
  }

  .bindingFiltersContainer {
    top: 235px;
  }

  .vs-con-input {
    width: 100%;
    float: none !important;
  }

  .vs-con-input-label {
    width: 100%;
  }

  .vue-treeselect__x-container:hover {
    color: $darkGrayColor;
  }

  .vue-treeselect__x {
    height: 10px !important;
  }

  .date-picker-li {
    .vue-daterange-picker {
      padding-bottom: 0 !important;
    }
  }

  .addMargin {
    margin-bottom: 30px !important;
  }
}

@media (max-width: 576px) {
  .whitespace-no-wrap {
    color: $babyBlueColor;
    margin-right: 10px;
  }
}

@media (max-width: 414px) {
  .filters-container {
    width: calc(100% - 42px);
  }
}

@media (max-width: 375px) {
  .filters-container {
    width: 300px;
  }
}

@media (max-width: 320px) {
  .filters-container {
    width: 245px;
  }
}
</style>
